import { createContext, ReactNode, useContext } from 'react';
import {
  MyBrightlinkRemoteConfig,
  useFetchFirebaseRemoteConfig,
} from './useFetchFirebaseRemoteConfig';

type FirebaseRemoteConfigProps = {
  children: ReactNode;
};

const MyBrightlinkRemoteConfigContext =
  createContext<MyBrightlinkRemoteConfig | null>(null);

export const FirebaseRemoteConfigProvider = ({
  children,
}: FirebaseRemoteConfigProps) => {
  const { remoteConfig } = useFetchFirebaseRemoteConfig();
  return (
    <MyBrightlinkRemoteConfigContext.Provider value={remoteConfig}>
      {children}
    </MyBrightlinkRemoteConfigContext.Provider>
  );
};

export const useRemoteConfig = () => {
  const remoteConfig = useContext(MyBrightlinkRemoteConfigContext);
  return remoteConfig;
};
